import { memo } from "react";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { HStack } from "@design-system/HStack/HStack";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AppliedTemplateSourceTag } from "@components/settings/ReportTemplates/apply/AppliedTemplateSourceTag";
import type { ReportTemplateActivityValue } from "./reportSettingsActivityRows";

interface ReportTemplateActivityCellProps {
    getValue: () => ReportTemplateActivityValue | null | undefined;
}

export const ReportTemplateActivityCell = memo(
    ({ getValue }: ReportTemplateActivityCellProps) => {
        const value = getValue();
        return (
            <ViewTableCell>
                {value ? (
                    <HStack as="span" align="center" gap={8}>
                        <BreakableText text={value.name} showTooltip />
                        {value.source && (
                            <AppliedTemplateSourceTag source={value.source} />
                        )}
                    </HStack>
                ) : (
                    <EmptyValue />
                )}
            </ViewTableCell>
        );
    },
);

ReportTemplateActivityCell.displayName = "ReportTemplateActivityCell";
